import React from "react";
import Image from "next/image";

const VillaStats = ({ views, recentViews }) => {
  return (
    <div className="flex flex-col flex-shrink-0">
      <div className="flex items-center justify-center py-2 px-3 bg-[#F3F6F9] border border-[#E7EDF4] rounded-md">
        <div className="flex items-center gap-2">
          <Image
            src="/icons/goz.svg"
            width={20}
            height={20}
            alt="Göz"
            className="object-contain"
          />
          <span className="text-themeBlack text-sm font-medium leading-normal">
            Son {recentViews}te{" "}
            <span className="font-bold text-themeSecondColor">{views}</span>{" "}
            kişi görüntüledi!
          </span>
        </div>
      </div>
    </div>
  );
};

export default VillaStats;
